
import { visitorService } from "@/service";
import { defineComponent, reactive, toRefs, watch, ref } from "vue";

export interface CustomerRef {
  onSearch(): void;
}
export default defineComponent({
  name: "Customer",
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  emits: ["change", "list"],
  setup(props, { emit }) {
    const { data } = toRefs(props);
    watch(
      () => data.value,
      now => {
        state.checked = now;
      }
    );

    const search_value = ref("");
    const state = reactive<any>({
      list: [],
      loading: false,
      finished: false,
      page: 1,
      checked: {}
    });

    const onLoad = async () => {
      try {
        const { data } = await visitorService.visitorTargetLists({
          target_type: 1,
          page: state.page,
          pagesize: 20,
          search_name: search_value.value
        });
        state.list.push(...data.data);
        state.loading = false;
        state.finished = false;
        state.page++;
        if (state.list.length >= data.total) {
          state.finished = true;
        }
      } catch (error) {
        state.list = [];
        state.finished = true;
      }
    };
    const onClick = (data: any) => {
      state.checked = data;
      emit("change", data);
    };

    const onSearch = async (from = "self") => {
      if (from === "index") search_value.value = "";
      state.page = 1;
      state.list = [];
      await onLoad();
      if (from === "index") return state.list;
    };
    return {
      state,
      search_value,
      onLoad,
      onClick,
      onSearch
    };
  }
});
